<template>
<v-text-field
    :label=label
    :value="value"
    disabled
    autocomplete="off"
    :hint="hint"
    persistent-hint
>

    <span
        slot="append-outer"
    >
         <m-edit-menu
            v-if="!read_only"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

        <m-date-picker-dialog
            ref="edit-dialog"
            :title="label"
            v-on:ok="setValue"
            :optional="optional"
        />

    </span>


</v-text-field>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        value: {
            type: [String, Number],
            default: function() { return ''; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        hint : {
            type: String,
            default: function() { return null; }
        },
    },

    methods: 
    {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
            this.$refs['edit-dialog'].showDialog(this.value);
        },

        setValue(new_value)
        {
            this.$emit('input',new_value);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>